<div class="dialog">
  @if (newsList && newsList.length) {
    <div class="dialog__nav-right-button">
      <span>
        <app-icon (click)="!isLastRecord && loadNextNews()" [color]="isLastRecord ? 'var(--gray-700)' : 'var(--white)'" iconName="chevron-right" size="20px" style="cursor: pointer"></app-icon>
      </span>
    </div>
    <div class="dialog__nav-left-button">
      <span>
        <app-icon (click)="!isFirstRecord && loadPrevNews()" [color]="isFirstRecord ? 'var(--gray-700)' : 'var(--white)'" iconName="chevron-left" size="20px" style="cursor: pointer"></app-icon>
      </span>
    </div>
  }

  @if (isMobileView()) {
    <div class="mobile-app-bar right-action-icons-only sticky-header">
      @if (isUserOwner || isUserAdmin) {
        @if (!alertType && !currentNews.denyById) {
          <div class="mobile-app-bar__action-icon">
            <app-icon (click)="editNewsBottomSheet(currentNews)" iconName="pencil" size="16px"></app-icon>
          </div>
        }

        <div class="mobile-app-bar__action-icon">
          <app-icon (click)="deleteNews(currentNews)" iconName="trash" size="16px"></app-icon>
        </div>
      }
      <div class="mobile-app-bar__action-icon">
        <app-icon (click)="close()" iconName="close" size="16px"></app-icon>
      </div>
    </div>
  } @else {
    <header class="dialog__header">
      <h3 class="dialog__header__title"></h3>
      <div class="dialog__header__action-buttons">
        @if (isUserOwner || isUserAdmin) {
          @if (!alertType || currentNews.denyById) {
            <div class="dialog__header__action-buttons__button">
              <span>
                <app-icon (click)="editNewsDialog()" [cssStyle]="{ margin: '4px' }" iconName="pencil" size="20px"></app-icon>
              </span>
            </div>
          }
          <div class="dialog__header__action-buttons__button">
            <span>
              <app-icon (click)="deleteNews(currentNews)" [cssStyle]="{ margin: '4px' }" iconName="trash-bin" size="20px"></app-icon>
            </span>
          </div>
        }
        <div class="dialog__header__action-buttons__button">
          <span>
            <app-icon (click)="closeDialog()" [cssStyle]="{ margin: '4px' }" iconName="close" size="20px"></app-icon>
          </span>
        </div>
      </div>
    </header>
  }

  <div class="dialog__content">
    @if (!isLoading && currentNews.title) {
      @if (alertType) {
        <app-alert-message
          [alertType]="alertType"
          [denyReason]="originalRecord.denyReason"
          [showCloseIcon]="false"
          [size]="'small'"
          [marginBottom]="updatedRecord && isUserAdmin ? '20px' : '30px'"
        ></app-alert-message>
      }

      @if (showUpdatedRecord && isUserAdmin) {
        <app-tabs-selection
          (selectedTab)="onUpdateRecordTabSelection($event)"
          [tabs]="[
            { displayName: 'current' | translate, label: 'current' },
            { displayName: 'Update' | translate, label: 'update' },
          ]"
          [selectedTabName]="'update'"
          marginBottom="30px"
        ></app-tabs-selection>
      }

      <div class="news-image background-loading">
        <img [src]="currentNews?.imageUrl" alt="" appDefaultImage="assets/images/defaults/news.png" loading="lazy" />
        <div class="author-details-bar">
          <div class="author-details-bar__info">
            <div class="author-details-bar__info__image background-loading-tiny">
              <img [appFetchProfileImage]="currentNews.user.memberId" alt="" loading="lazy" src="assets/images/placeholder.png" />
            </div>
            <div class="author-details-bar__info__name">
              <p translate>Published by</p>
              <h5>{{ currentNews?.user?.fullName | translate }}</h5>
            </div>
          </div>

          <div class="author-details-bar__date">
            <p>{{ currentNews.publicationDateFrom | date: 'dd.MM.y' }}</p>
          </div>
        </div>
      </div>

      <div class="flex-row-between-center flex-nowrap mt-25">
        <h5 class="news-title">{{ currentNews.title }}</h5>
        <app-badge
          [text]="(currentNews.audience === NewsType.Chairman ? 'Chairman' : currentNews.audience === NewsType.Group ? 'Group' : 'News') | translate"
          [type]="currentNews.audience === NewsType.Chairman ? 'primary' : currentNews.audience === NewsType.Group ? 'primary' : 'primary'"
        ></app-badge>
      </div>
      @if (!isLoading) {
        <article [innerHTML]="currentNews?.text" class="news-text">{{ currentNews?.text }}</article>
      } @else {
        <ng-container *ngTemplateOutlet="loader"></ng-container>
      }
      <div class="flex-row-start-center gap-6 flex-wrap">
        @for (tag of currentNews.newsTags; track tag) {
          <p class="news-text tag tag-display mr-1">{{ tag.tagName | humanize | truncateText: 30 }}</p>
        }
      </div>
    } @else {
      <ng-container *ngTemplateOutlet="loader"></ng-container>
    }
  </div>

  @if ((showUpdatedRecord || currentNews?.approvedStatus === ApprovedStatus.UnApproved) && isUserAdmin) {
    <footer class="dialog__footer">
      <div class="dialog__footer__buttons">
        <app-button (clickEvent)="denyNews(currentNews, $event)" [idleText]="'Deny' | translate" cssClass="button-simple"></app-button>
        <app-button (clickEvent)="approveNewsUpdate(currentNews, currentNews?.approvedStatus !== ApprovedStatus.UnApproved, $event)" [idleText]="'Publish' | translate"></app-button>
      </div>
    </footer>
  }
</div>

<ng-template #loader>
  <ngx-skeleton-loader
    [theme]="{
      height: '300px',
    }"
    count="1"
  ></ngx-skeleton-loader>

  <ngx-skeleton-loader
    [theme]="{
      height: '30px',
    }"
    count="1"
  ></ngx-skeleton-loader>

  <ngx-skeleton-loader
    [theme]="{
      height: '100px',
    }"
    count="1"
  ></ngx-skeleton-loader>

  <ngx-skeleton-loader
    [theme]="{
      height: '30px',
    }"
    count="1"
  ></ngx-skeleton-loader>
</ng-template>
